const hostITD = window.location.host==='localhost:2000' ?'http://127.0.0.1:8000':'https://back.clases.club';
const Config = {
    apiGateway: 'https://48aone7mh3.execute-api.us-east-2.amazonaws.com/pro',
    cloudFront: 'https://d33zbbj9uff4yk.cloudfront.net/',
    apiPhp: hostITD,
}

export default Config;